(() => {
  if (customElements.get('cista-announcement')) return;
  customElements.define('cista-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.slides = Array.from(this.querySelectorAll('[data-announcement-message]'));
      this.messages = this.querySelector('[data-announcement-messages]');
      if (this.slides.length < 2 || !this.messages) return;
      this.connected = true;
      this.hovered = false;
      this.focused = this.contains(document.activeElement);
      this.editing = false;
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.onKeydown = event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const directions = { ArrowLeft: -1, ArrowRight: 1 };
        if (!Object.hasOwn(directions, event.key) && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        this.show(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + directions[event.key], true);
      };
      this.onPointerDown = event => {
        if (event.isPrimary === false || event.button > 0) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
        this.stopRotation();
        this.messages.setPointerCapture?.(event.pointerId);
      };
      this.onPointerUp = event => {
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        this.gesture = null;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (Math.abs(dx) < 28 || Math.abs(dx) < Math.abs(dy) * 1.4) {
          this.scheduleRotation();
          return;
        }
        this.show(this.index + (dx < 0 ? 1 : -1), true);
      };
      this.onPointerCancel = event => {
        if (!this.gesture || this.gesture.id !== event.pointerId) return;
        this.gesture = null;
        this.scheduleRotation();
      };
      this.onPointerEnter = event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.stopRotation();
      };
      this.onPointerLeave = () => {
        this.hovered = false;
        this.scheduleRotation();
      };
      this.onFocusIn = () => {
        this.focused = true;
        this.stopRotation();
      };
      this.onFocusOut = event => {
        if (this.contains(event.relatedTarget)) return;
        this.focused = false;
        this.scheduleRotation();
      };
      this.onVisibilityChange = () => this.scheduleRotation();
      this.onBlockSelect = event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) {
          this.editing = true;
          this.show(index, true);
        }
      };
      this.onBlockDeselect = () => {
        this.editing = false;
        this.scheduleRotation();
      };
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('pointerenter', this.onPointerEnter);
      this.addEventListener('pointerleave', this.onPointerLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.messages.addEventListener('pointerdown', this.onPointerDown);
      this.messages.addEventListener('pointerup', this.onPointerUp);
      this.messages.addEventListener('pointercancel', this.onPointerCancel);
      this.messages.addEventListener('lostpointercapture', this.onPointerCancel);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.messages.tabIndex = 0;
      this.show(this.index);
      this.classList.add('is-ready');
      this.scheduleRotation();
    }
    stopRotation() {
      clearTimeout(this.timer);
      this.timer = null;
    }
    scheduleRotation() {
      this.stopRotation();
      if (!this.connected || !this.isConnected || document.hidden || this.hovered || this.focused || this.gesture || this.editing) return;
      this.timer = setTimeout(() => {
        this.show(this.index + 1);
        this.scheduleRotation();
      }, 4000);
    }
    show(index, manual = false) {
      this.messages.setAttribute('aria-live', manual ? 'polite' : 'off');
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      if (manual) this.scheduleRotation();
    }
    disconnectedCallback() {
      this.stopRotation();
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('pointerenter', this.onPointerEnter);
      this.removeEventListener('pointerleave', this.onPointerLeave);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.messages?.removeEventListener('pointerdown', this.onPointerDown);
      this.messages?.removeEventListener('pointerup', this.onPointerUp);
      this.messages?.removeEventListener('pointercancel', this.onPointerCancel);
      this.messages?.removeEventListener('lostpointercapture', this.onPointerCancel);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.gesture = null;
      this.connected = false;
    }
  });
})();
